module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "block"
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "txtcontent strip"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _c('a', {
    staticClass: "btn bookingbtn wow3",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.childOpen()
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 41.4 47.3"
    }
  }, [_c('title', [_vm._v("step")]), _c('path', {
    attrs: {
      "d": "M13.3,31.3h-0.1l-8.4,0.4c-2.1,0.1-3.7,1.8-3.6,3.9c0,0.1,0,0.1,0,0.2c1.1,10.3,6,11.4,8.1,11.4c0.4,0,0.8,0,1.1-0.1c1.5-0.2,2.9-1,3.7-2.3c2.7-4,0.7-11.7,0.4-12.6C14.4,31.7,13.9,31.3,13.3,31.3zM12,43.4c-0.4,0.7-1.2,1.1-2,1.1H9.9c-0.2,0-0.4,0.1-0.5,0c-1.3,0-4.5-0.8-5.4-8.7c0-0.4,0.1-0.8,0.3-1.1c0.2-0.3,0.6-0.5,1-0.5l5.8-0.3h0.1c0.7,0,1.3,0.5,1.4,1.2C13.2,39,13,41.9,12,43.4z"
    }
  }), _c('path', {
    attrs: {
      "d": "M31.9,32.8l-8.1-2.5c-0.1,0-0.3-0.1-0.4-0.1c-0.5,0-0.9,0.2-1.1,0.7c-0.5,0.8-4.4,7.8-2.8,12.3c0.5,1.4,1.6,2.6,3,3.1c0.8,0.4,1.7,0.6,2.6,0.6c2.6,0,6.3-1.6,9.2-9.2c0.7-1.9-0.2-4.1-2.2-4.8C32,32.9,31.9,32.8,31.9,32.8L31.9,32.8z M31.7,37.1c-2.5,6.2-5.2,7.2-6.6,7.2l0,0c-0.5,0-1-0.1-1.4-0.3L23.5,44c-0.8-0.2-1.3-0.8-1.6-1.6c-0.6-1.7,0-4.5,1.6-8.1c0.3-0.7,1-1,1.7-0.8l5.5,1.7c0.4,0.1,0.7,0.4,0.9,0.8C31.8,36.4,31.8,36.8,31.7,37.1z"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.8,0H9.4c-7.1,0.1-8.9,10.4-9,10.9C-0.8,17.3,1,27.6,1,28c0.1,0.6,0.7,1.1,1.3,1.1h9.8c1.4,0,2.7-0.8,3.4-2.1c3.9-8,1.9-16.7,1.8-16.8C15.4,1,11.4,0,9.8,0zM9.8,2.6L9.8,2.6c3.1,0,4.8,7.4,5,8.2c0,0.1,1.8,7.7-1.5,14.8c-0.2,0.5-0.7,0.8-1.3,0.8H4.7c-0.7,0-1.3-0.5-1.4-1.2C2.8,21.8,2.2,15.5,3,11.4c0.3-1.6,0.8-3.1,1.5-4.6c1.3-2.7,3-4.1,5-4.1L9.8,2.6C9.7,2.6,9.8,2.6,9.8,2.6L9.8,2.6z"
    }
  }), _c('path', {
    attrs: {
      "d": "M35.5,1c-0.5-0.2-1-0.3-1.5-0.2c-2.1,0-5.4,1.4-8.8,8.1c0,0-4.2,7.9-2.5,16.7c0.3,1.4,1.3,2.5,2.7,2.9l9.5,2.5c0.1,0,0.2,0,0.3,0c0.5,0,1-0.3,1.2-0.8c0.2-0.4,4.5-9.9,4.9-16.4C41.4,13.4,42.2,2.9,35.5,1z M38.7,13.6C38.5,17.9,36.3,23.8,35,27c-0.2,0.5-0.7,0.9-1.3,0.9c-0.1,0-0.2,0-0.4,0l-7-1.8c-0.5-0.2-0.9-0.6-1-1.1c-1.4-7.7,2.2-14.6,2.3-14.7c3-6.1,5.5-6.8,6.4-6.8c0.2,0,0.3,0,0.5,0.1l0.2,0.1C39.4,4.8,38.8,13.5,38.7,13.6z"
    }
  })])]), _c('span', [_vm._v("線上預約參訪")])])]), _vm._v(" "), _c('div', {
    staticClass: "contactinfo"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "wow1"
  }, [_c('li', {
    staticClass: "phone"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 41.78 35.83"
    }
  }, [_c('title', [_vm._v("phone")]), _c('path', {
    attrs: {
      "fill": "#076588",
      "d": "M39.14,15.7a2,2,0,0,0,1.93-1.63c.27-1.4.48-2.81.66-4.07A3.55,3.55,0,0,0,40,6.4C31.84.7,23.16-1.21,14.25.74A30,30,0,0,0,1.92,6.49,3.44,3.44,0,0,0,.79,8a14.38,14.38,0,0,0-.65,6.67,1.89,1.89,0,0,0,1.78,1.73l.43,0a10.36,10.36,0,0,0,1.12.08l4.15-.1a2.44,2.44,0,0,0-.33.56l-.69,1.58C6,19.94,5.38,21.38,4.82,22.82A15.56,15.56,0,0,0,4.94,33.7a2.53,2.53,0,0,0,2.61,2,4.06,4.06,0,0,1,.58,0,5.91,5.91,0,0,0,.69.05h7.49c5.59,0,11.18,0,16.76,0h0A3.27,3.27,0,0,0,36.18,34a11.27,11.27,0,0,0,1.25-8.38,36.72,36.72,0,0,0-4.08-9.1l-.11-.2,1.05-.12C35.89,16,37.53,15.84,39.14,15.7ZM25.54,33.15l-9.44-.09L7.72,33a.61.61,0,0,1-.16,0,.5.5,0,0,1-.07-.16c-1-3.24-1.11-5.69-.38-7.92.56-1.72,1.3-3.44,2-5.1.25-.57.49-1.14.73-1.72a1.5,1.5,0,0,0-.12-1.74l1.41,0a1.81,1.81,0,0,0,1.36-.57,1.88,1.88,0,0,0,.43-1.47c-.08-1-.21-2.33-.42-3.66s-.22-1.38,1-1.77l.12,0A25.72,25.72,0,0,1,28,8.82a6.49,6.49,0,0,1,1.18.41,5.22,5.22,0,0,1-.08,1.24c0,.08,0,.15,0,.23s0,.2-.05.3-.07.46-.11.69a4.68,4.68,0,0,0,.17,3.07l-.2.14c-.59.42-1.16.82-1.7,1.25a4,4,0,0,0-.53.5,2,2,0,0,0-.39-.58,9.7,9.7,0,0,0-2.09-1.76,7.68,7.68,0,0,0-5.25-.58c-3.63.61-6.39,3.28-6.71,6.5a8.39,8.39,0,0,0,5.32,8.92,8.64,8.64,0,0,0,10.35-3.33A7.51,7.51,0,0,0,28.74,19c0-.15-.06-.37-.08-.32a4.48,4.48,0,0,1,1.84-1.47,49.54,49.54,0,0,1,4,8.24,9.32,9.32,0,0,1-.55,7,1,1,0,0,1-1.08.65c-1.29,0-2.58,0-3.86,0S26.71,33.16,25.54,33.15ZM2.85,12.52c.09-1,.18-2.08.37-3.08A2.09,2.09,0,0,1,4,8.38,27.45,27.45,0,0,1,15.81,3.25c7.65-1.39,14.85.21,22,4.89A2.17,2.17,0,0,1,39,10.6c-.08.47-.15.94-.22,1.41l-.12.82c0,.22,0,.25-.41.27-1.42.08-2.85.21-4.24.33l-1.48.13a2.63,2.63,0,0,0-.49.11c-.29.08-.44,0-.48,0s-.1-.16-.08-.46c0-.7.15-1.4.27-2.14l.12-.79c.3-2.09-.18-2.95-2.08-3.67A24,24,0,0,0,18.46,5.16,42.36,42.36,0,0,0,14.19,6l-1.47.32a5.73,5.73,0,0,0-1.24.47A2.65,2.65,0,0,0,9.67,10c.14,1.16.31,2.38.52,3.63q0,.1,0,.17h-.08c-.87,0-1.74,0-2.59.1l-1.07.06-1.05-.06c-.89,0-1.78-.1-2.68-.12C2.78,13.33,2.82,12.93,2.85,12.52Zm21.08,13.4a5.53,5.53,0,0,1-5.66.57A5.42,5.42,0,0,1,14.94,22a4.28,4.28,0,0,1,2.12-4.61,7.15,7.15,0,0,1,3.62-1.12,5.53,5.53,0,0,1,2.64.69,3.16,3.16,0,0,1,.54.34,3.37,3.37,0,0,1-.53.47l-.48.36c-.6.45-1.23.92-1.81,1.44a1.67,1.67,0,0,0-.34,1.69,1.11,1.11,0,0,0,.82.63,1.24,1.24,0,0,0,1.11-.14c1.29-1,2.33-1.92,3.25-2.75a4.41,4.41,0,0,0,.2.94,6.63,6.63,0,0,1,.3,2.31A4.81,4.81,0,0,1,23.93,25.92Z"
    }
  })])]), _c('a', {
    attrs: {
      "href": "tel:0228914606"
    }
  }, [_vm._v("02-2891-4606")])]), _vm._v(" "), _c('li', {
    staticClass: "tax"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 41 27.3"
    }
  }, [_c('title', [_vm._v("tax")]), _c('path', {
    attrs: {
      "fill": "#0B5F7E",
      "d": "M39.2,13.3c0-0.1-0.1-0.2-0.1-0.3c-0.5-1-1.7-3.3-4.1-3.3l-0.6,0c-0.5,0-1.1,0-1.6-0.1c-0.3,0-0.7,0-1,0l0-1c0-0.8,0-1.7-0.1-2.5c0-0.8-0.1-1.5-0.1-2.3l-0.1-1.8c0-0.8-0.6-1.4-1.4-1.4l-0.5-0.1c-0.4,0-1-0.1-1.5-0.1c-1.2,0-1.9,0-2.5,0c-0.7,0-1.3,0-2.9,0l-2.7,0c-0.2,0-0.5,0-0.8,0.2c-0.3,0.2-0.6,0.6-0.7,1c-0.1,0.6,0.5,1.1,0.9,1.2c0.3,0.1,0.6,0.1,0.8,0.1l2.6,0c0.8,0,2.6,0,4.4,0.1l1.8,0l0.1,3.5c0,1.3,0.1,2.6,0.1,3.9c0,0.4,0.1,0.7,0.2,0.9c-0.3,0-0.6,0-0.9,0c-4.3,0-8.7,0-13,0l-5,0l0-0.4c0-1.4,0-2.8,0-4.2l0.2,0.1c0.1,0.1,0.4,0.5,0.9,0.5c0.6,0,3.6,0,4.2,0l0.9-0.1c0.2,0,0.4-0.1,0.5-0.2c0.2-0.3,0.2-0.7,0.1-1.2c0-0.2-0.1-0.5,0-0.7l0.1-0.7c0.1-0.7,0-1.4,0-2.1l0-0.6c0-0.3,0-1.3-0.8-1.6c-0.8-0.4-3.1,1-3.4,1.2c-1.4,1-2.8,2.2-4.4,3.5c-0.5,0.4-0.6,1-0.7,1.5c0,1.3-0.1,2.6-0.1,3.9l0,0.2c-0.1-0.1-0.2-0.2-0.4-0.3c-1.2-0.8-3.3-0.5-4.1,0.6c-0.8,1-1.4,1.9-1.8,2.7c-0.9,1.8-1.4,5.6-1.6,7.9l-0.1,0.7C0,23.1,0,24.2,0,25.1c0,1.5,1.2,1.6,1.6,1.6l0.2,0c0.2,0,0.4,0,0.6,0L6,26.9c2.5,0.1,5,0.1,7.6,0.2c5.6,0.1,11.8,0.1,19.5,0.2l0.7,0c1.2,0,2.4,0,3.6,0l1.8,0c1,0,1.5-0.5,1.7-1.5c0.1-0.4,0.1-1,0.1-1.6C41,21.2,40.6,15.9,39.2,13.3z M29.4,16.2c0,0.9,0,1.8,0,2.3l-1.4,0c-1.2,0-2.4,0-3.6,0c-3.4,0-7-0.1-10.6-0.1c-0.8,0-1.7,0-2.5-0.1l-0.4,0v-4.5h18.7C29.4,14.2,29.4,15.2,29.4,16.2z M27.3,20.9l2.5,0c0.9,0,1.4-0.1,1.7-0.2c0.1-0.1,0.3-0.2,0.5-0.4l0.1-0.1l-0.3-6.9c0-0.3,0-0.6-0.1-0.9c0-0.2-0.1-0.4-0.2-0.5c0.7,0,1.5,0,2.1,0.1l0.5,0c1.5,0.5,2.3,1.6,2.3,1.6l0.1,0.1c0,0,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.4l0,0.1c0.8,1.4,1.4,5.2,1.5,8.1c0,0.6,0,1.3,0,2l0,0.1c-11.1,0.1-22.8-0.1-36-0.4c0-1.6,0.2-5,0.4-6.3c0.4-2.2,1.2-4,2.4-5.5c0.2-0.3,0.5-0.4,0.9-0.4c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0.1,0.1c0.3,0.8,1,1.3,1.8,1.4l0,0.5c0,0.3,0,1.1,0,2c0,1.2,0,2.6,0.1,2.9c0.1,1.1,0.5,1.6,1.7,1.7c0.1,0,0.2,0,0.3,0l1.4,0c1,0,1.9,0.1,2.9,0.1C18.8,20.9,23.1,20.9,27.3,20.9z M12.9,4.7c0.7-0.6,1.5-1.2,2.2-1.8c0,0.6-0.1,1.2-0.1,1.8C14.5,4.8,13.6,4.7,12.9,4.7z"
    }
  })])]), _c('a', {
    attrs: {
      "href": "tel:0228914606"
    }
  }, [_vm._v("02-2891-3024")])]), _vm._v(" "), _c('li', {
    staticClass: "mail"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 39.47 28.79"
    }
  }, [_c('title', [_vm._v("mail")]), _c('path', {
    attrs: {
      "fill": "#076588",
      "d": "M19.92,17c-.32.26-.33.25-.56,0-.79-.7-1.6-1.39-2.4-2.07-1.41-1.2-2.86-2.44-4.23-3.72A28.76,28.76,0,0,1,7.25,5a1.41,1.41,0,0,0-1-.57L6,4.43,5.26,4.2,5,4.93a2,2,0,0,1-.08.2A1.42,1.42,0,0,0,4.85,6.3,7.8,7.8,0,0,0,5.94,8,70.51,70.51,0,0,0,17.51,19c1.91,1.47,2.44,1.47,4.31,0A146.21,146.21,0,0,0,37.4,4.76a7.1,7.1,0,0,0,1-1.39,1.7,1.7,0,0,0,.19-1.55A1.65,1.65,0,0,0,37.38.94a16,16,0,0,0-2.8-.41c-2.77-.15-5.92-.31-9-.38C18.37,0,10.91-.16,3.44.34.86.51.06,1,0,3.78,0,10.67,0,17.59,0,22.84a20.44,20.44,0,0,0,.27,2.78c.05.36.1.71.15,1.07a1.76,1.76,0,0,0,1.75,1.67c.44,0,.88.07,1.33.12.59.06,1.18.12,1.78.14q5.85.18,11.67.18c5.3,0,10.56-.11,15.74-.33a33.42,33.42,0,0,0,3.85-.4c1.56-.25,1.89-.76,2.09-2.18a93.72,93.72,0,0,0,.74-15.81A12,12,0,0,0,39,7.39a1.62,1.62,0,0,0-1.64-1,1.25,1.25,0,0,0-.92.63,1.49,1.49,0,0,0,0,1.32,1.52,1.52,0,0,1,.14.58v2.31c0,2.59,0,5.26-.07,7.88,0,1.2-.16,2.43-.28,3.62-.08.84-.17,1.68-.23,2.52,0,.08,0,.13,0,.14l-.2,0-1.61.13c-1,.09-2,.18-3.06.19-6.84.07-14.23.12-23.24.16-1,0-2.07,0-3.08-.09l-1.69-.07H3a7.6,7.6,0,0,0-.07-1c0-.23-.06-.47-.06-.7l-.07-3.27c-.09-4.16-.19-8.45-.23-12.68,0-1.23.07-2.46.15-3.76,0-.4.05-.8.08-1.2A283.66,283.66,0,0,1,35,3.31,157.51,157.51,0,0,1,19.92,17Z"
    }
  })])]), _c('a', {
    attrs: {
      "href": "mailto:TCAA@taiwancurio.org.tw",
      "onclick": "gaclick('btn_email')"
    }
  }, [_vm._v("TCAA@taiwancurio.org.tw")])])]), _vm._v(" "), _c('div', {
    staticClass: "fbcontent wow2"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ftaiwancurio%2F%3Ffref%3Dts&tabs=timeline&width=300&height=380&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId&target=\"_top\"",
      "scrolling": "no",
      "frameborder": "0",
      "allowTransparency": "true"
    }
  })], 1)])])]), _vm._v(" "), _vm._m(5)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookmark"
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/bookmark/v/contact.svg"),
      "alt": "聯絡多寶"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "wow1"
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/title/contact1.svg"),
      "alt": "想更瞭解我們在做什麼"
    }
  }), _c('br'), _c('img', {
    staticClass: "secondtxt",
    attrs: {
      "src": require("../../asset/svg/title/contact2.svg"),
      "alt": "走一趟多寶學堂吧！"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "wow2"
  }, [_vm._v("真心地邀請你，來關渡更認識我們，可以看到美麗的畫作、喝一杯多寶創作人手沖的好咖啡"), _c('br'), _vm._v("感受他們獨有的特質、動人的世界")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contactpic"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/contact_pic.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("聯絡"), _c('b', [_vm._v("多寶藝術學堂")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('address', [_c('p', [_vm._v("11259 臺北市北投區大度路三段296巷33弄7號1樓")]), _c('br', {
    staticClass: "m_only"
  }), _c('span', [_vm._v("捷運淡水線"), _c('b', [_vm._v("關渡站")]), _vm._v("1號出口往星巴克方向，經過鍋爐咖啡，右邊第一條巷弄進來 (總步行約三分鐘)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42945a1b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Contact.vue
// module id = 249
// module chunks = 0